<template>
  <input
    :name="name"
    :type="inputType"
    :placeholder="placeholderText"
    :min="minIntegerValue"
    :value="modelValue"
    class="border border-gray-300 rounded-lg p-3 hover:border-green-600 text-sm text-gray-500 focus:outline-none focus:border-green-500 active:border-green-500"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
export default {
  name: "OnBoardingInput",

  props: {
    placeholderText: { type: String, default: "" },
    inputType: { type: String, default: "text" },
    name: { type: String, default: "" },
    minIntegerValue: { type: Number, default: 0 },
    modelValue: { type: [String, Number], default: "" },
  },

  emits: ["update:modelValue"],
}
</script>
